     
<style lang="less" scoped>
@import url('../../../style/common/variable.less');
*{list-style-type: none;}
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.country{width:1200px;margin: auto;}
.block{width: 50%; margin-right: 2%;}
i{font-size: 19px;color: #289FDE;}
h3{line-height: 50px;text-align: left;margin:0;}
.real-time{width:48%; height: 400px;
  .gengduo{line-height: 50px;text-align: right;font-size: 16px;font-weight: 600;margin: auto;}
}
.qyzs{display: flex;width: 1200px; margin: auto;flex-direction: column;margin-top: 40px;}
.head{display: flex;justify-content: space-between;width: 100%;align-items: center;}
.gengduo{line-height: 50px;font-size: 16px;font-weight: 600;}
.exhibition{width: 1400px;display: flex; margin: 0;padding: 0;margin-left: -20px;flex-wrap: wrap;
  li{width: 255px;height: 174px;margin: 0px 28px;border-radius: 2px;display: flex;flex-direction: column;background-color: #f7f7f7;margin-bottom: 40px;cursor: pointer;}
}
.hzxm{display: flex; margin: 10px auto;flex-direction: column;}
.kyxm{margin-bottom: 20px;}
.SwiperGroup{margin-left: 20px;}
.second{position: relative;text-align:left;overflow: hidden;
.seamless-warp{width: 100%;height: 392px;overflow: hidden;}
p{background-color: #f2f2f2;line-height: 32px;}
ul{list-style: none;}}
li{width:100%;height: 30px;color: #666666;padding-top: 10px;border-bottom: 1px solid #f2f2f2;cursor: pointer;}
li:hover{color:#037cff}
.left{float: left;}
.right{float: left;
.col1{float:left;width:260px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
// .col2{margin-left: 70px;}
.col3{float:right;margin-right: 10px;}}
.more{width:1200px;margin-top: -50px;margin-right:23px;font-weight: 600;text-align:right;cursor: pointer;}
.more1{width:1200px;margin-top: -20px;margin-right:23px;font-weight: 600;text-align:right;cursor: pointer;}
.headtitle{display: flex;flex-direction: row;justify-content: space-between;width:1200px;align-items: center;height: 27px;margin-top: 50px;}
.headtitle1{display: flex;flex-direction: row;justify-content: space-between;width:1200px;align-items: center;height: 60px;font-weight:bold;font-size:18px;margin-top:10px;margin-bottom:10px;}
.hyxx{display: flex;width: 1200px; margin: auto;flex-direction: column;}
.meeting{display: flex;justify-content: space-between;
  ul{margin: 0;padding: 0;width: 49%;height: 310px;
    p{height: 38px;background-color: #f6f6f6;margin:0; letter-spacing: 1px;font-size: 18px;line-height: 38px;text-align: left;padding: 0 10px;}
    li{height: 45px;padding: 0 10px; display: flex; justify-content:space-between;align-items:center; font-size: 16px;letter-spacing: 1px;border-bottom: 2px solid #f6f6f6;}
  }
}
.vitrual{display: flex;justify-content: space-between;overflow: hidden;padding: 0px;
  .video{height: 680px;width: 100%;}
}
.button-hyxx{float: right;margin-top:0px;}
/deep/.vjs-big-play-button{left: 0;right: 0;top: 0;bottom: 0;margin: auto;}
.exhibit{float: right;
  p{margin: 0;padding: 0; display: flex; letter-spacing: 1px;color: #666666; display: flex;height: 25px; text-align: left;
    i{font-size: 30px;}
    span{margin-left:10px ; line-height: 35px;}
  }
}
.jrzt{text-align: right;line-height: 60px;letter-spacing: 1px;color: #1296db;font-size: 18px;cursor: pointer;}
.details{position: relative;
  .image{float: left;width: 570px;height: 354px;margin-right: 30px;}
  .prjtext{background: white;height: 354px;
    .first{background: #eee;font-family: Microsoft YaHei;padding: 10px 0px;
      p{margin: 0px 20px 0px 20px;font-size: 24px;color: #000;text-align: left;}
    }
  .wybh_xx{background: white;font-size: 16px;text-align: left;color: #000;margin-top: 40px;}
  }
}
.class1{background:#eeeeee}
.class2{background:#185aa0}
.fontclose1{color: #fff;}
.fontclose2{color: #000}
.gengduo{cursor: pointer;}
.qyname{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}

@media screen and (max-width: @max-screen)
{
  h3{font-size: 16px;}
  .hzxm{width: 95%; overflow: hidden;}
  .left{width: 100%;
    .col1{margin-left: 0px;width:70%;overflow: scroll;display: inline-block;white-space: nowrap;text-overflow: ellipsis;}
    .col2{float:right;margin-right: 10px;}
  }
  .hyxx{width: 95vw; margin: auto;}
  .second{margin: 0px;
    ul{margin: 0; padding: 0;}
    p{width: 100%;margin-left: 0px;font-size: 16px;}
    span{margin: 0px 10px;}
  }
  li{font-size: 12px;display: flex; justify-content: space-around;}
  .right{margin-left: 0px;width: 100%;
    .col2{margin-left: 0px;}
  }
  .video{height: auto !important;}
  .image{height: auto !important;}
  .prjtext{height: 680px !important;
    .wybh_xx{background: white;font-size: 16px;text-align: left;color: #000;margin-top: 40px;display: flex;flex-direction: column;flex-wrap: wrap;align-content: space-between;align-items: flex-start;justify-content: center;}
  }
  .button-hyxx{float: none !important;}
  .exhibition{width: 95vw; margin: 0;
    li{width: 100%; height: auto; margin: 0; margin-top: 0.1rem;}
  }
  .details{width: 95vw;
    .image{width: 95vw;}
  }
  .qyzs{width: 95vw;
    .head{width: 95vw;margin: auto;}
  }
}
@media screen and (min-width: @max-screen)
{
  h3{font-size: 18px;}
  .hzxm{width: 1200px;}
  .head{height: 75px;}
  .left{width: 620px;
    .col1{margin-left: 20px;width:460px;overflow: hidden;float:left;white-space: nowrap;text-overflow: ellipsis;}
    .col2{float:right;margin-right: 10px;}
  }
  .second{margin: 0px;display:flex;
    p{width: 580px;margin-left: 40px;font-size: 20px;}
    span{margin: 0px 20px;}
  }
  li{font-size: 16px;}
  .right{margin-left: -20px;width: 620px;
    .col2{margin-left: 70px;}
  }
}
</style>

<template>
  <div class="center">
    <div class="xnzt hyxx" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
      <div class="head">
        <h3 :style="screenWidth < 912 ? {'font-size': 14 + 'px'} : ''">
          <i class="iconfont icon-D"></i>
          中国—东盟矿业合作论坛云上展厅 / Virtual exhibition hall
        </h3>
      </div>
      <div class="vitrual">
        <div class="video">
          <div v-if="playerOptions.sources[0].src===''">视频播放失败</div>
          <video-player ref="videoPlayer" v-else :playsinline="true" :options="playerOptions" style="width: 1200px;" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''"></video-player>
        </div>
      </div>
      <div class="exhibit">
          <div class="jrzt">
            <a href="https://www.camining.cn/yzt/sceneFront/index.html" target="_blank">
              <span style="color:#289FDE;">进入展厅</span>
              <i class="iconfont icon-hj2" style="vertical-align: middle;font-size:25px"></i>
            </a>
          </div>
        </div>
    </div>
    <!-- 加盟展厅 -->
    <div class="hzxm">
       <div class="head">
        <h3>
          <i class="iconfont icon-qiye"></i>
          加盟展厅 / Franchise exhibition hall
        </h3>
      </div>
      <SwiperYSZT :swiperYSZTList="swiperYSZTdata" @clickSwiperYSZT="goJMZT"></SwiperYSZT>
      <el-button type="primary" @click="goChxxb" style="width: 100px;margin:10px auto;"><span style="font-size: 16px;">我要参展</span></el-button>
    </div>
    <!-- 会议发布 -->
    <div class="scheduler hyxx">
      <div class="head">
        <h3>
          <i class="iconfont icon-huiyi2"></i>
          会议日历 / Conference Scheduler
        </h3>
      </div>
      <MeetingList :TabsList="scheduler" :activeName="active1"  @handleClick="goHyxqzk" @tabClick="onMeeting"></MeetingList>
    </div>
    <!-- 我要办会 -->
    <div class="holdmeeting hyxx" style="margin-top: 30px;">
      <div class="head">
        <h3>
          <i class="iconfont icon-huiyi2"></i>
          我要办会 / Hold the meeting
        </h3>
      </div>
      <div class="details">
        <div class="image">
          <img src="static/images/image_wybh.png" alt="" style="width:100%;height:100%">
        </div>
        <div class="prjtext">
          <div class="first">
            <p>面向社会提供各类矿业项目合作与交流的线上、线下办会服务。</p>
          </div>
          <div class="wybh_xx">
            <p>联系人：冯主任</p>
            <p>电&nbsp;&nbsp;&nbsp;&nbsp;话：0771-2706557</p>
            <p>邮&nbsp;&nbsp;&nbsp;&nbsp;箱：camining@163.com</p>
            <p>地&nbsp;&nbsp;&nbsp;&nbsp;区：广西壮族自治区-南宁市</p>
            <p>地&nbsp;&nbsp;&nbsp;&nbsp;址：南宁市青秀区建设路1号</p>
          </div>
          <el-button class="button-hyxx" type="primary" @click="goBhxxb" style="float: right;margin-top:0px;"><span style="font-size: 16px;">填写办会信息</span></el-button>
        </div>
      </div>
    </div>
    <!-- 企业展示 -->
    <div class="qyzs">
      <div class="head">
        <h3>
          <i class="iconfont icon-qiye"></i>
          企业展示 / Eenerprise Exhibition
        </h3>
        <span class="gengduo" @click="goQyzhList">更多</span>
      </div>
      <ul class="exhibition" >
        <li v-for="(each, index) in exhibition" :key="index" @click="clickCompany(each)" >
          <div style="width:100%;height: 130px;" :style="screenWidth < 912 ? {'height': 250 + 'px'} : '130px'" >
            <img :src="each.thumb" alt="" style="width:100%;height:100%">
          </div>
          <p class="qyname" style="margin: 10px 10px;">{{each.company}}</p>
        </li>
      </ul>
    </div>
    <!-- 矿业项目\矿业设备\矿产品 -->
    <div class="hzxm">
       <div class="head">
        <h3>
          <i class="iconfont icon-xiangmu"></i>
          矿业项目 / Mining project
        </h3>
        <span class="gengduo" @click="onKyxmList">更多</span>
      </div>
      <CardImgkyxm class="kyxm" :cardImgkyxmList="cardImgkyxmList" @clickImgName="getKyxmDetails"></CardImgkyxm>
      <div class="head">
        <h3>
          <i class="iconfont icon-mineral"></i>
          矿业设备 / Mining equipment
        </h3>
        <span class="gengduo" @click="onKysbList">更多</span>
      </div>
      <SwiperGroup class="SwiperGroup" :swiperGroupList="swiperGroupListSB" @clickSwiper="onclickSwiperSB"></SwiperGroup>
      <div class="head">
        <h3>
          <i class="iconfont icon-yaoji"></i>
          矿业药剂 / Mining medicament
        </h3>
        <span class="gengduo" @click="onKyyjList">更多</span>
      </div>
      <SwiperGroup class="SwiperGroup" :swiperGroupList="swiperGroupListYJ" @clickSwiper="onclickSwiperYJ"></SwiperGroup>
      <div class="head">
        <h3>
          <i class="iconfont icon-zhubao"></i>
          珠宝玉石 / Jewelry and Jade
        </h3>
        <span class="gengduo" @click="onZbysList">更多</span>
      </div>
      <SwiperGroup class="SwiperGroup" :swiperGroupList="swiperGroupListZB" @clickSwiper="onclickSwiperZB"></SwiperGroup>
      <p>
      <div class="head">
        <h3>
          <i class="iconfont icon-qiye"></i>
          矿产品 / Mineral products
        </h3>
        <span class="gengduo" @click="onKcpList">更多</span>
      </div>
      <div class="second">
        <div class="left">
          <p><span>供求信息</span></p>
          <vue-seamless-scroll :data="secondLList" class="seamless-warp" :class-option="classOption">
            <ul>
              <li class="DataList_top" v-for="(item,index) in secondLList" :key="index" @click="getKcpDetails(item)">
                <span class="col1"> {{ item.title }} </span>
                <span class="col2"> {{ item.typeid | formatJYLX() }} </span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="right">
          <p><span>热门信息</span></p>
          <vue-seamless-scroll :data="secondRList" class="seamless-warp" :class-option="classOption">
            <ul>
              <li v-for="(item,index) in secondRList" :key="index" @click="getKcpDetails(item)">
                <span class="col1"> {{ item.title }} </span>
                <span class="col2" > {{ item.typeid | formatJYLX() }} </span>
                <span class="col3" v-if="ifShowFlag"> {{ item.time * 1000 | formatDate() }} </span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperYSZT from '.././assembly/SwiperYSZT'
import SwiperImg from '.././assembly/SwiperImg'
import NewsEXhibition from '.././assembly/NewsEXhibition'
import playVideo from '../method/playVideo'
import National from '.././assembly/National'
import MeetingList from '.././assembly/MeetingList.vue'
import CardImgkyxm from '../assembly/CardImgkyxm'
import SwiperGroup from '../assembly/SwiperGroup'
import arrayFun from '../method/array.js'
import filters from '../method/filter.js'
let obj = {}
let meeting = []
let num2 = 1
export default {
  components: {SwiperYSZT, SwiperImg, NewsEXhibition, National, MeetingList, CardImgkyxm, SwiperGroup},
  mixins: [playVideo, filters],
  name: '',
  data()
  {
    return {
      newsKYZXLis: [],
      exhibition: [],
      currentPage: 1,
      flag1: true,
      flag2: false,
      flag3: false,
      flag4: false,
      TabsList: [],
      active: '',
      active1: '近期会议',
      Scheduler: [],
      cardImgkyxmList: [],
      swiperGroupListSB: [],
      swiperGroupListYJ: [],
      swiperGroupListZB: [],
      secondLList: [],
      secondRList: [],
      WybhData: [],
      currentdata: {},
      select: 0,
      swiperYSZTdata: [
        { pic: 'static/images/JMZT/ZT1.jpg', name: 'ZT1', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT2.jpg', name: 'ZT2', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT3.jpg', name: 'ZT3', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT4.jpg', name: 'Zt4', type: 'VR', title: '展厅3D模型' },
        { pic: 'static/images/JMZT/ZT5.jpg', name: 'ZT5', type: 'VR', title: '展厅3D模型' }
      ],
      ifShowFlag: true,
      screenWidth: window.innerWidth
    }
  },
  computed: {
    player()
    {
      return this.$refs.videoPlayer.player
    },
    NewsKYZXLis()
    {
      return this.newsKYZXLis
    },
    classOption()
    {
      return {
        step: 0.5,
        direction: 1
      }
    },
    Exhibition()
    {
      return this.exhibition
    },
    tabsList()
    {
      return this.TabsList
    },
    scheduler()
    {
      return this.Scheduler
    }
  },
  created()
  {
    this.getExhibition()
    this.getPlayerOptions()
    this.getKyxm()
    this.getKcp()
    this.getKysb()
    this.getKyyj()
    this.getZbys()
    this.getHyfb()
    this.getWybhData()
  },

  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },

  methods:
  {
    /**
     * 企业展示数据
     */
    getExhibition()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 26, _exp: 'level=1 and examine = 0', orderby: 'id DESC', init: 0, pageno: 1, pagesize: 8}
      window.post.getPost(paras).then((ret) =>
      {
        this.exhibition = ret[0].data
      })
    },
    /**我要办会-获取所有数据-安进 */
    getWybhData()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 52, _exp: 'id>0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push(item)
        })
        this.WybhData = temp
        this.currentdata = this.WybhData[0]
      })
    },
    // 矿业项目
    getKyxm()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 12, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 4}
      window.post.getPost(paras).then((ret) =>
      {
        this.cardImgkyxmList = []
        ret[0].data.forEach(item =>
        {
          this.cardImgkyxmList.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, description: '经营范围', text: item.introduce, time: item.addtime, company: item.company})
        })
      })
    },
    // 矿业设备
    getKysb()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 18, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupListSB = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, time: item.adddate, company: item.company})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.swiperGroupListSB.push(tempList[i])
      })
    },
    // 矿业药剂
    getKyyj()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 20, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupListYJ = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, time: item.adddate, company: item.company})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.swiperGroupListYJ.push(tempList[i])
      })
    },
    // 珠宝玉石
    getZbys()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 16, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        this.swiperGroupListZB = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', hits: item.hits, time: item.adddate, company: item.company})
        })
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.swiperGroupListZB.push(tempList[i])
      })
    },
    // 矿产品
    getKcp()
    {
      let paras23 = {cmd: 'query', _major: 11, _minor: 14, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras23).then((ret) =>
      {
        let arr = []
        this.secondLList = []
        this.secondRList = []
        ret[0].data.forEach(item =>
        {
          this.visit += item.hits
          arr.push({id: item.id, title: item.title, typeid: item.typeid, time: item.addtime, hits: item.hits, company: item.company})
        })
        this.release += ret[0].data.length
        this.deal = ret[0].data.length // 成交总数

        for (let i = 0; i < 10; i++)
          this.secondLList.push(arr[i]) // 供求信息
        let temp = JSON.stringify(arr)
        let tempList = JSON.parse(temp)
        tempList.sort(arrayFun.compareBtoS('hits'))
        for (let i = 0; i < 10; i++)
          this.secondRList.push(tempList[i]) // 热门信息
      })
    },
    /**中国—东盟矿业合作论坛云上展厅-安进 */
    getPlayerOptions()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 56, _exp: 'type=? and shows =1', types: 's', vals: '1', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 1}
      window.post.getPost(paras).then((ret) =>
      {
        this.playerOptions.sources[0].src = ret[0].data[0].video ? ret[0].data[0].video : 'static/images/moren.jpg'
      })
    },
    //获取会议发布列表数据
    getHyfb()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 53, _exp: 'id>0 and examine = 0', orderby: 'addtime Desc', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        obj = {}
        meeting = []
        meeting = ret[0].data
        ret.forEach(e =>
        {
          let type = e.type
          if (!obj[type])
            obj[type] = []
          obj[type].push(e)
        })
        this.active = Object.keys(obj)[0]
        this.onMeeting()
      })
    },
    /**
     * 会议日历分类
     * @method String active 当前tab选中页
     * @method String click 会议发布项目
     */
    onMeeting(active, click)
    {
      //判断点击加载更多是否属于当前项目
      if (!click === '会议日历')
        return false
      //当前选中的tab页
      if (active)
      {
        this.active1 = active
        num2++
      }
      this.Scheduler = []
      let index = 4 * num2
      let recent = [] //往期
      let period = [] //近期
      meeting.forEach(e =>
      {
        let now = new Date().valueOf()
        let front = now - 1296000000
        let after = now + 1296000000
        let addtime = e.addtime * 1000
        if (front <= addtime && addtime <= after && period.length < index)
        {
          e.A = '近期会议'
          period.push(e)
        }
        else if (addtime < front)
        {
          e.A = '往期会议'
          recent.push(e)
        }
      })
      this.Scheduler.push({title: '近期会议', content: period, cli: '会议日历'}, {title: '往期会议', content: recent, cli: '会议日历'})
    },
    //矿业项目列表页
    onKyxmList()
    {
      let url = this.$router.resolve({path: '/HzxmKYXMList'})
      window.open(url.href, '_blank')
    },
    //矿产品列表页
    onKcpList()
    {
      let url = this.$router.resolve({path: '/HzxmKCPList'})
      window.open(url.href, '_blank')
    },
    //矿业设备列表页
    onKysbList()
    {
      let url = this.$router.resolve({path: '/HzxmKYSBList'})
      window.open(url.href, '_blank')
    },
    //矿业药剂列表页
    onKyyjList()
    {
      let url = this.$router.resolve({path: '/HzxmKYJSList'})
      window.open(url.href, '_blank')
    },
    //珠宝玉石列表页
    onZbysList()
    {
      let url = this.$router.resolve({path: '/HzxmZBYSList'})
      window.open(url.href, '_blank')
    },
    //跳转矿业项目详情页
    getKyxmDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYXMDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿产品详情页
    getKcpDetails(item)
    {
      let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿业设备详情页
    onclickSwiperSB(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYSBDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转矿业药剂详情页
    onclickSwiperYJ(item)
    {
      let url = this.$router.resolve({path: '/HzxmKYJSDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转珠宝玉石详情页
    onclickSwiperZB(item)
    {
      let url = this.$router.resolve({path: '/HzxmZBYSDetails', query: {company: item.company, id: item.id}})
      window.open(url.href, '_blank')
    },
    //跳转会议详情召开中
    goHyxqzk(each)
    {
      if (each.A === '近期会议')
      {
        let url = this.$router.resolve({path: '/Hyxqzk', query: {id: each.id}})
        window.open(url.href, '_blank')
      }
      else
      {
        let url = this.$router.resolve({path: '/Hyxqwq', query: {id: each.id}})
        window.open(url.href, '_blank')
      }
    },
    clickCompany(each)
    {
      let url = this.$router.resolve({path: '/CompanyShow', query: {id: each.id}})
      window.open(url.href, '_blank')
    },
    // 跳转到企业展示列表页
    goQyzhList()
    {
      let url = this.$router.resolve({path: '/QyzsList'})
      window.open(url.href, '_blank')
    },
    // 跳转到我要参展报名页
    goChxxb()
    {
      let url = this.$router.resolve({path: '/Chxxb'})
      window.open(url.href, '_blank')
    },
    // 跳转到我要办会报名页
    goBhxxb()
    {
      let url = this.$router.resolve({path: '/Bhxxb'})
      window.open(url.href, '_blank')
    },
    // 跳转到加盟展厅
    goJMZT(name)
    {
      let url = this.$router.resolve({name: 'FictitiousZT', params: {name: name}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Exhibition.vue